import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Button from 'react-bootstrap-button-loader';
import { ButtonTrash } from '../../../common/buttons';

import {
  InputField,
  SelectField,
  required,
  integer,
  minValue
} from '../../../form';

const hasDisabledValueField = (field, method) => {
  switch (field) {
    case 'url':
    case 'videourl':
      switch (method) {
        case 'uri_encode': return true;
        default: return false;
      }
    case 'bid':
    case 'cpv':
      switch (method) {
        case 'd2m':
        case 'c2m':
        case 's_d2m':
        case 's_c2m':
          return true;
        default: return false;
      }
    default: return false;
  }
};

class FeedModifier extends Component {
  remainingModifierOptions(selectedModifier) {
    const { currentModifierTypes } = this.props;

    return [
      { label: '', value: null },
      { label: 'Bid', value: 'bid' },
      { label: 'Category', value: 'category' },
      { label: 'City', value: 'city' },
      { label: 'Company', value: 'company' },
      { label: 'Country', value: 'country' },
      { label: 'CPV', value: 'cpv' },
      { label: 'Date', value: 'date' },
      { label: 'Location', value: 'location' },
      { label: 'Postal Code', value: 'postalcode' },
      { label: 'State', value: 'state' },
      { label: 'Status', value: 'status' },
      { label: 'Title', value: 'title' },
      { label: 'URL', value: 'url' },
      { label: 'Video URL', value: 'videourl' },
    ].filter((o) => !currentModifierTypes.includes(o.value) || selectedModifier === o.value);
  }

  clearModifierField(index) {
    const { formValues } = this.props;

    delete formValues[index].method;
    delete formValues[index].value;
  }

  clearValueField(index) {
    const { formValues } = this.props;

    delete formValues[index].value;
  }

  renderModifierField(modifier, index) {
    const { formValues } = this.props;
    let options = [];
    const fieldValue = get(formValues[index], 'field', null);
    const clear = this.clearValueField.bind(this, index);

    if (['bid', 'cpv'].includes(fieldValue)) {
      options = [
        { label: '', value: null },
        { label: 'Dollars to Mills', value: 'd2m' },
        { label: 'Cents to Mills', value: 'c2m' },
        { label: 'String Dollars to Mills', value: 's_d2m' },
        { label: 'String Cents to Mills', value: 's_c2m' },
        { label: 'Override', value: 'ovr' },
      ];
    } else if (['url', 'videourl'].includes(fieldValue)) {
      options = [
        { label: '', value: null },
        { label: 'Prepend', value: 'prepend' },
        { label: 'Append', value: 'append' },
        { label: 'URI Encode', value: 'uri_encode' },
        { label: 'Override', value: 'ovr' },
      ];
    } else if (['date'].includes(fieldValue)) {
      options = [
        { label: '', value: null },
        { label: 'Parse Date', value: 'parse_date' },
        { label: 'Override', value: 'ovr' },
      ]
    } else if (fieldValue !== null) {
      options = [
        { label: '', value: null },
        { label: 'Prepend', value: 'prepend' },
        { label: 'Append', value: 'append' },
        { label: 'Override', value: 'ovr' },
      ];
    }

    return (
      <Field
        type='text'
        name={`${modifier}.method`}
        label='Modifier'
        component={SelectField}
        options={options}
        onChange={field => (
          ['bid', 'cpv', 'url', 'videourl'].includes(fieldValue) && hasDisabledValueField(fieldValue, field.value) ? clear() : null
        )}
        validate={[required]}
        normalize={field => (field ? field.value : field)}
      />
    );
  }

  renderValueField(modifier, index) {
    const { formValues } = this.props;
    const isDisabled = hasDisabledValueField(formValues[index].field, formValues[index].method);

    if (['bid', 'cpv'].includes(formValues[index].field)) {
      const fieldReadable = formValues[index].field === 'bid' ? 'Bid' : 'CPV';
      const method = formValues[index].method;

      return (
        <Field
          type={method === 'ovr' ? 'number' : 'text'}
          name={`${modifier}.value`}
          label='Value'
          disabled={isDisabled}
          component={InputField}
          helpText={method === 'ovr' ? `${fieldReadable} must be in mills` : ''}
          parse={value => (method === 'ovr' ? parseInt(value, 10) : value)}
          validate={method === 'ovr' ? [required, integer, minValue(1)] : []}
        />
      );
    }

    return (
      <Field
        type='text'
        name={`${modifier}.value`}
        disabled={isDisabled}
        label='Value'
        component={InputField}
        validate={isDisabled ? [] : [required]}
      />
    );
  }

  render() {
    const { formValues, fields } = this.props;

    return (
      <div>
        {fields.map((modifier, index) => {
          return (
            <Row key={index}>
              <Col md={3}>
                <Field
                  type='text'
                  name={`${modifier}.field`}
                  label='Field'
                  component={SelectField}
                  options={this.remainingModifierOptions(formValues[index] ? formValues[index].field : null)}
                  onChange={this.clearModifierField.bind(this, index)}
                  normalize={field => (field ? field.value : field)}
                  validate={[required]}
                />
              </Col>
              <Col md={3}>
                {this.renderModifierField(modifier, index)}
              </Col>
              <Col md={4}>
                {this.renderValueField(modifier, index)}
              </Col>
              <Col md={2} style={{ marginTop: '30px' }}>
                <ButtonTrash
                  bsSize='xs'
                  onClick={() => fields.remove(index)}
                  bsStyle='danger'
                  className='m-l-xs'
                />
              </Col>
            </Row>
          );
        })}
        <div style={{ textAlign: 'center', margin: '25px 0px' }}>
          <Button
            bsSize='lg'
            onClick={() => fields.push({ field: null, method: null, value: null })}
            bsStyle='success'
            className='m-l-xs'
            style={{ marginBottom: '10px' }}
          >
            Add Modifier
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { form } = state;

  if (form[ownProps.meta.form] && form[ownProps.meta.form].values) {
    const modifiers = form[ownProps.meta.form].values.modifiers;
    const currentModifierTypes = (modifiers || []).map((m) => (m.field ? m.field : null)).filter(m => m !== null);

    return { formValues: modifiers, currentModifierTypes };
  }

  return { formValues: [], currentModifierTypes: [] };
};

export default connect(mapStateToProps)(FeedModifier);
